import React, {Component} from "react";
import { connect } from 'react-redux';
import { Field, reduxForm,formValueSelector } from 'redux-form';
import * as actions from '../../redux/auth/actions';
import RFRenderTextField from '../../components/RFComponents/RFRenderTextField'

class LoginWithTAC extends Component {

  componentDidUpdate(){
    const { auth,history } = this.props
    if (auth.user && auth.jwtToken) {
      history.push('/')
    }
  }

  render() {
    const { auth,handleSubmit,pristine,submitting,email,history } = this.props
  
    return (
      <div>
        <form onSubmit={handleSubmit} > 
          <div className='container text-center'>
            <div className='row'>
                  <br /><br />
            </div>
            <div className='row'>
                  <br /><br />
            </div>
            <div className='row'>
                <div className='col-sm loginLogo'>
                  <img src='/img/swarm-colony-logo-v2.png'  />
                </div>
            </div>
            <div className='row'>
                  <br />
            </div>
            {auth.error?(
              <div className='row'>
                  <div className='col-sm'>
                      <div className="alert alert-danger" role="alert">
                          <strong>ERROR!</strong> {auth.error}
                      </div>
                  </div>
              </div> 
              ):null}
              {auth.validatedEmail?(
              <div className='row'>
                  <div className='col-sm'>
                    <div className="alert alert-success" role="alert">
                      <h4 className="alert-heading">2FA Authentication</h4>
                      <p>Your 2FA authentication token has been sent to {email}.</p>
                    </div>
                  </div>
              </div> 
              ):null}
              <div className='row'>
                <div className='col-sm'>
                  <Field
                      name="email"
                      component={RFRenderTextField}
                      label="Email"
                      margin={'normal'}
                      style={{width: '30%'}}
                  />
                </div>
              </div>
              {!auth.validatedEmail && email?(
              <div className='row'>
                  <div className='col-sm'>
                      <button className="btn btn-outline-primary" type="button" onClick={()=>getLoginTacOnClick(this.props)} >
                          Get Login TAC
                      </button>
                  </div>
              </div> 
              ):null}
              {auth.validatedEmail?(
              <div className='row'>
                <div className='col-sm'>
                  <Field
                      name="loginTac"
                      component={RFRenderTextField}
                      label="Login TAC"
                      margin={'normal'}
                      style={{width: '30%'}}
                  />
                </div>
              </div>  
              ):null}
              {auth.validatedEmail?(
              <div className='row'>
                  <div className='col-sm'>
                      <button className="btn btn-outline-primary" type="submit" disabled={pristine || submitting}>
                          Login with TAC
                      </button>
                  </div>
              </div> 
              ):null}
              <div className='row'>
                  <br />
              </div> 
          </div>
        </form>
      </div>
    );
  }
}

const getLoginTacOnClick=props=>{
   const { email } = props;
   props.validateEmail(email);
}

const validate = (values,props) => {
  const errors = {};
  let requiredFields = [
      'email',
      'loginTac'
  ];

  requiredFields.forEach(field => {
      if (!values[field]) {
          errors[field] = 'Required'
      }
  })
  return errors;
}

const submit = (values, dispatch, props) => {
  props.loginWithTac(values['email'],values['loginTac']);
}

const form = 'LoginWithTACReduxForm'
const selector = formValueSelector(form)

let LoginWithTACForm = reduxForm({
  form: form,
  validate: validate,
  onSubmit: submit
})(LoginWithTAC)

const mapStateToProps = (state, ownProps) => {
  return {
     auth: state.auth,
     email: selector(state,'email')
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
      validateEmail: (email) => {
          dispatch(actions.validateEmail(email))
      },
      loginWithTac: (email,loginTac) => {
          dispatch(actions.loginWithTac(email,loginTac))
      }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(LoginWithTACForm);



// WEBPACK FOOTER //
// ./src/views/Login/LoginWithTAC.js